import React from 'react';
import PropTypes from 'prop-types';
import s from './styles.module.css';

const LegendGradient = (props) => {
  const getColors = () => {
    const colorsArray = [];
    for (let i = 0; i < props.colors.length; i++) {
      colorsArray.push(
        <div className={s.colorBox} key={props.colors[i]} style={{ backgroundColor: props.colors[i], height: `${props.height}px` }} />
      );
    }
    return colorsArray;
  };

  return (
    <div className={s.legendContainer}>
      <div className={s.colorsContainer}>
        {getColors()}
      </div>
      <div className={s.range}><span>{props.labels.left}</span><span>{props.labels.right}</span></div>
    </div>
  );
};

LegendGradient.propTypes = {
  colors: PropTypes.array,
  labels: PropTypes.shape({ left: PropTypes.string, right: PropTypes.string }),
  height: PropTypes.number,
};

export default LegendGradient;
